import type { StateOrName } from "@uirouter/core/lib/state/interface";

import { swSettings } from "app/common/services/swSettings";
import { getCountries } from "app/components/filters-bar/utils";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const isNewHomepage = () => {
    return swSettings.components.Home.resources.ShowNewHomepage;
};

export const isAeoHomepage = () => {
    return swSettings.components.Home.resources.AEOHomePage;
};

export const getDefaultParamsForState = (state: StateOrName) => {
    const defaultParams = {
        isWWW: "*",
        country: getCountries()?.[0]?.id ?? WORLDWIDE_COUNTRY_ID,
        duration: "3m",
        webSource: devicesTypes.TOTAL,
    };
    const defaultParamsFromState = proNavigator.getState(state).defaultQueryParams;
    return defaultParamsFromState ? { ...defaultParams, ...defaultParamsFromState } : { ...defaultParams };
};
